export const API = {
    // 测试环境
    DEV_SERVER: 'https://demopdcapi.cumtsn.com',
    // 线上环境
    PRO_SERVER: 'https://demopdcapi.cumtsn.com'
}